module.exports = __webpack_public_path__ + "static/avatar.62bd9f83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jpg/avatar.jpg
// module id = 186
// module chunks = 114276838955818 198517197184460